import './my-profile-private.scss';
import MyLogsView from "./myLogsView/myLogsView";
import ViewedTmdbItems from "./viewedTmdbItems/viewedTmdbItems";
import MyProfileNotes from "./my-profile-notes/my-profile-notes";

const MyProfilePrivate = () => {
    return (
        <>
            <div className="text-muted my-profile-private-description">
                <i className="fa-solid fa-lock"></i> Esta sección es privada y solo tú puedes verla.
            </div>
            <MyProfileNotes/>
            <ViewedTmdbItems/>
            <MyLogsView/>
        </>
    )
}

export default MyProfilePrivate;
